import { withAuthRedirect } from '../hocs';
import { Panel, PanelHeader, PanelContent } from '../atoms';
import { LoanFilter, LoanList } from '../organisms';
import { useMambuLoanStore } from '../../contexts';

const SNPLPage = () => {
  const loading = useMambuLoanStore((s) => s.isLoading);
  const loans = useMambuLoanStore((s) => s.searchResults);

  const productType = 'SNPL';

  return (
    <Panel>
      <PanelHeader>
        <h1>Study Now Pay Later</h1>
        <LoanFilter productType={productType} />
      </PanelHeader>
      <PanelContent>
        <LoanList productType={productType} loans={loans} isLoading={loading} />
      </PanelContent>
    </Panel>
  );
};

const SecureSNPLPage = withAuthRedirect(SNPLPage);
export { SecureSNPLPage as SNPLPage };
